import { render, staticRenderFns } from "./ClientOnboardingForm.vue?vue&type=template&id=bbf8f606"
import script from "./ClientOnboardingForm.vue?vue&type=script&lang=js"
export * from "./ClientOnboardingForm.vue?vue&type=script&lang=js"
import style0 from "./ClientOnboardingForm.vue?vue&type=style&index=0&id=bbf8f606&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf8f606')) {
      api.createRecord('bbf8f606', component.options)
    } else {
      api.reload('bbf8f606', component.options)
    }
    module.hot.accept("./ClientOnboardingForm.vue?vue&type=template&id=bbf8f606", function () {
      api.rerender('bbf8f606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientForm/components/ClientOnboardingForm.vue"
export default component.exports